export const ERROR_MESSAGE = {
  BABY_GROWTH: {
    INVALID_AGE: 'babyGrowth.error.invalidAge',
    INVALID_MEASUREMENT_DATE: 'babyGrowth.error.invalidMeasurementDate',
    MEASUREMENT_DATE_LOWER_THAN_BIRTHDAY:
      'babyGrowth.error.measurementDateLowerThanBirthday',
    BIRTHDAY_REQUIRED: 'babyGrowth.error.birthdayRequired',
    HEAD_REQUIRED: 'babyGrowth.error.headRequired',
    HEIGHT_REQUIRED: 'babyGrowth.error.heightRequired',
    WEIGHT_REQUIRED: 'babyGrowth.error.weightRequired',
    INVALID_VALUE: 'babyGrowth.error.invalidValue',
    AT_LEAST_ONE_OF: 'babyGrowth.error.atLeastOneOf',
    AT_LEAST_ONE_OF_VN: 'babyGrowth.error.atLeastOneOfVn',
  },
}
